// src/pages/admin/Dashboard.js
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ChevronDown, ChevronRight, User, LogOut } from "lucide-react";
import AdminTopbar from "../../components/admin/AdminTopbar";
import AdminLayout from "../../layouts/admin/AdminLayout";

/**
 * 간단한 상단바 + 좌측 아코디언 사이드바 + 메인 카드 그리드 레이아웃
 * - Tailwind 기반
 * - 버튼 경로(to)와 섹션/카드 목록은 아래 CONFIG에서 손쉽게 수정 가능
 */

export default function AdminDashboard() {
  return (
    <AdminLayout>
      <MainCards />
    </AdminLayout>
  );
}

/* ---------------- Sidebar ---------------- */
const SIDEBAR_SECTIONS = [
  {
    title: "온라인지원 관리",
    items: [{ label: "온라인지원 관리", to: "/admin/contact/list" }],
  },
  //   {
  //     title: "회원 관리",
  //     items: [
  //       { label: "회원 목록", to: "/admin/members" },
  //       { label: "가입 요청", to: "/admin/members/requests" },
  //     ],
  //   },
];

/* ---------------- Main Cards ---------------- */

const CARDS = [
  {
    title: "온라인지원 관리",
    desc: "온라인지원 내역을 관리할 수 있습니다.",
    to: "/admin/contact/list",
    button: "온라인지원 관리",
    color: "blue",
  },
  {
    title: "채용공고 관리",
    desc: "채용공고 내역을 관리할 수 있습니다.",
    to: "/admin/employment/list",
    button: "채용공고 관리",
    color: "pink",
  },
  {
    title: "소식 관리",
    desc: "소식 확인하고 관리할 수 있습니다.",
    to: "/admin/news/list",
    button: "소식 관리",
    color: "green",
  },
  {
    title: "관리자 관리",
    desc: "관리자계정을 확인하고 관리할 수 있습니다.",
    to: "/admin/user/list",
    button: "관리자 관리",
    color: "orange",
  },
];

function MainCards() {
  return (
    <main className="w-full">
      <div className="mb-4 flex items-center justify-center">
        <h1 className="text-2xl font-extrabold tracking-tight text-slate-900 md:text-3xl">
          관리자 대시보드
        </h1>
      </div>

      <div className="grid grid-cols-1 gap-5 md:grid-cols-2 xl:grid-cols-3">
        {CARDS.map((c) => (
          <Card key={c.title} {...c} />
        ))}
      </div>
    </main>
  );
}

function Card({ title, desc, to, button, color }) {
  const bg = {
    blue: "bg-blue-600 hover:bg-blue-700",
    orange: "bg-orange-600 hover:bg-orange-700",
    green: "bg-emerald-600 hover:bg-emerald-700",
    amber: "bg-amber-500 hover:bg-amber-600",
    teal: "bg-teal-600 hover:bg-teal-700",
    purple: "bg-violet-600 hover:bg-violet-700",
    pink: "bg-pink-600 hover:bg-pink-700",
    cyan: "bg-cyan-600 hover:bg-cyan-700",
    slate: "bg-slate-800 hover:bg-slate-900",
  }[color || "blue"];

  return (
    <div className="rounded-2xl border bg-white p-5 shadow-sm">
      <div className="text-lg font-bold text-blue-900">{title}</div>
      <p className="mt-2 text-sm text-slate-600">{desc}</p>
      <div className="mt-4">
        <Link
          to={to}
          className={`inline-flex items-center justify-center rounded-xl px-4 py-2 text-sm font-semibold text-white ${bg}`}
        >
          {button}
        </Link>
      </div>
    </div>
  );
}
